// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-zNNG","col":"styles_col__19ogq"};